import { Controller } from "@hotwired/stimulus"
import { marked } from "marked"
import DOMPurify from "dompurify"

export default class extends Controller {
  static targets = ["source", "panel", "tabEdit", "tabPreview"]

  connect() {
    marked.use({ gfm: true, breaks: true })
  }

  edit(event) {
    event?.preventDefault()
    this.sourceTarget.classList.remove("hidden")
    this.panelTarget.classList.add("hidden")
    this._activateTab(true)
  }

  preview(event) {
    event?.preventDefault()
    const raw = this.sourceTarget.value || ""
    const html = DOMPurify.sanitize(marked.parse(raw))
    this.panelTarget.innerHTML = html.trim()
      ? html
      : '<p class="opacity-60 text-sm m-0">（无内容）</p>'
    this.sourceTarget.classList.add("hidden")
    this.panelTarget.classList.remove("hidden")
    this._activateTab(false)
  }

  _activateTab(editActive) {
    if (this.hasTabEditTarget) {
      this.tabEditTarget.classList.toggle("btn-active", editActive)
    }
    if (this.hasTabPreviewTarget) {
      this.tabPreviewTarget.classList.toggle("btn-active", !editActive)
    }
  }
}
